const REVIEW_MIN_LENGTH = 12;
const REVIEW_MAX_LENGTH = 3000;

function comments() {
    const form = document.querySelector('.toptech-comment-form');

    if (!form || !window.fetch) {
        return;
    }

    const reviewField = form.querySelector('[name="comment"]');
    const submitButton = form.querySelector('[type="submit"]');
    const status = form.querySelector('.toptech-comment-form-status');
    const commentsShell = form.closest('.toptech-comments-shell');

    if (!reviewField || !submitButton || !status || !commentsShell) {
        return;
    }

    const showStatus = (message, type) => {
        status.hidden = false;
        status.classList.toggle('is-success', type === 'success');
        status.classList.toggle('is-error', type === 'error');
        status.textContent = message;
    };

    const normalizedReviewLength = () => Array.from(
        reviewField.value.trim().replace(/\s+/g, ' ')
    ).length;

    const insertComment = (data) => {
        if (!data.commentHtml) {
            return;
        }

        let list = commentsShell.querySelector('.comment-list');

        if (!list) {
            const commentsArea = document.createElement('div');
            commentsArea.className = 'comments-area';
            list = document.createElement('div');
            list.className = 'comment-list';
            commentsArea.appendChild(list);
            form.closest('.comment-respond').insertAdjacentElement('afterend', commentsArea);
        }

        if (data.parentId) {
            const parent = commentsShell.querySelector(`#comment-${Number(data.parentId)}`);
            if (parent) {
                let children = parent.querySelector(':scope > .children');
                if (!children) {
                    children = document.createElement('div');
                    children.className = 'children';
                    parent.appendChild(children);
                }
                children.insertAdjacentHTML('beforeend', data.commentHtml);
                return;
            }
        }

        list.insertAdjacentHTML('afterbegin', data.commentHtml);
    };

    form.addEventListener('submit', (event) => {
        event.preventDefault();

        if (!form.reportValidity()) {
            return;
        }

        const contentLength = normalizedReviewLength();
        if (contentLength < REVIEW_MIN_LENGTH || contentLength > REVIEW_MAX_LENGTH) {
            showStatus('Reviews must be between 12 and 3,000 characters.', 'error');
            status.focus();
            return;
        }

        const body = new URLSearchParams(new window.FormData(form));
        submitButton.disabled = true;
        form.classList.add('is-submitting');
        showStatus('Submitting your review…', 'progress');

        window.fetch(form.getAttribute('action'), {
            method: 'POST',
            credentials: 'same-origin',
            headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'},
            body,
        }).then((response) => response.json().catch(() => null).then((result) => ({response, result})))
            .then(({response, result}) => {
                if (!response.ok || !result || !result.success) {
                    const message = result && result.data && result.data.message
                        ? result.data.message
                        : 'Your review could not be submitted. Please try again.';
                    throw new Error(message);
                }

                insertComment(result.data);
                commentsShell.querySelector('.toptech-comments-empty')?.remove();

                const count = commentsShell.querySelector('.toptech-comments-heading > span');
                if (count && result.data.reviewCountLabel) {
                    count.textContent = result.data.reviewCountLabel;
                }

                form.reset();
                showStatus(result.data.message, 'success');
                status.focus();
            })
            .catch((error) => {
                showStatus(error.message || 'Your review could not be submitted. Please try again.', 'error');
                status.focus();
            })
            .finally(() => {
                submitButton.disabled = false;
                form.classList.remove('is-submitting');
            });
    });
}

export {comments};
